var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Generate an array containing tick numbers from 1..16.
var arrayOfTicks = Array.from({ length: 16 }, function (_, i) { return i + 1; });
// Given a ChordEventValue, generate a set of notes.
export function generateNotesFromChord(chordEventValue) {
    var playStyle = chordEventValue.playStyle;
    var notes = __spreadArray([], chordEventValue.notes, true);
    if (notes.length === 0) {
        return [];
    }
    if (playStyle === 'arpeggio-up') {
        notes.sort();
    }
    else if (playStyle === 'arpeggio-down') {
        notes.sort().reverse();
    }
    else if (playStyle === 'arpeggio-random') {
        // Randomize using Fisher-Yates Algorithm
        for (var i = notes.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = notes[i];
            notes[i] = notes[j];
            notes[j] = temp;
        }
    }
    if (playStyle === 'arpeggio-random') {
        return arrayOfTicks.map(function (tick) {
            return {
                tick: tick,
                note: notes[Math.floor(Math.random() * notes.length)],
            };
        });
    }
    else if (playStyle === 'together') {
        return notes.map(function (note) {
            return {
                tick: 1,
                note: note,
            };
        });
    }
    else {
        if (playStyle === 'arpeggio-up') {
            notes.sort();
        }
        else if (playStyle === 'arpeggio-down') {
            notes.sort().reverse();
        }
        return arrayOfTicks.map(function (tick) {
            return {
                tick: tick,
                note: notes[(tick - 1) % notes.length],
            };
        });
    }
}
// Given a ChordEventValue, generate a set of data for graphing it.
export function generateGraphDataFromChord(_a) {
    var chordEventValue = _a.chordEventValue, width = _a.width, height = _a.height, numOctaves = _a.numOctaves, startOctave = _a.startOctave, padding = _a.padding, noteHeightScale = _a.noteHeightScale;
    var notes = generateNotesFromChord(chordEventValue);
    // Note widths fit in the space; note heights are exaggerated.
    var noteWidth = Math.ceil((width - 2 * padding) / 16);
    var noteHeight = Math.ceil(((height - 2 * padding) / (12 * numOctaves)) * noteHeightScale);
    // Blocks' locations will be for their upper-left corners, so ensure
    // that the space we are filling counts for the full size of the blocks.
    var useWidth = width - 2 * padding - noteWidth;
    var useHeight = height - 2 * padding - noteHeight;
    return notes.map(function (note) {
        return {
            x: 1 + ((note.tick - 1) * useWidth) / (16 - 1) + padding,
            y: 1 +
                padding +
                useHeight -
                ((note.note - startOctave * 12) * useHeight) / (numOctaves * 12 - 1),
            width: noteWidth,
            height: noteHeight,
        };
    });
}
